export const sortByClaimId = (
  firstItem: { claimId: string },
  secondItem: { claimId: string },
): number => (firstItem.claimId > secondItem.claimId ? 1 : -1);
